module.exports = __webpack_public_path__ + "fonts/c858ae9a/proxima_nova_reg-punc.eot";